export default "__VITE_ASSET__Ct05Yaw8__"